import { httpClient } from "./BaseApi";

const WHATSAPP_CHATTING_PATIENTS_LIST = "api/patient/whatsapp/list.json";
const WHATSAPP_CHATTING_PATIENT_MESSAGES = "api/patient/whatsapp/messages.json";
const WHATSAPP_CHATTING_PATIENT_MESSAGE_READ = "api/patient/whatsapp/mark-messages-as-read.json";
const WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE = "api/patient/whatsapp/chat/item.json";
const WHATSAPP_CHATTING_PATIENT_ARCHIVE = "api/patient/whatsapp/archive.json";
const WHATSAPP_CHATTING_PATIENT_SEND_IMAGE = "api/patient/whatsapp/chat/send-image.json";

const WhatsAppChattingApi = {
  getList: (params) => httpClient.get(WHATSAPP_CHATTING_PATIENTS_LIST, { params }),
  getPatientWhatsappMessages: (params) =>
    httpClient.get(WHATSAPP_CHATTING_PATIENT_MESSAGES, { params }),
  markAsRead: (params) => httpClient.put(WHATSAPP_CHATTING_PATIENT_MESSAGE_READ, { data: params }),
  sendPatientWhatsappMessages: (data) =>
    httpClient.post(WHATSAPP_CHATTING_PATIENT_SEND_MESSAGE, { data }),
  archivePatientChatting: (data) => httpClient.put(WHATSAPP_CHATTING_PATIENT_ARCHIVE, { data }),
  sendPatientWhatsappImage: (formData) =>
    httpClient.request({
      url: WHATSAPP_CHATTING_PATIENT_SEND_IMAGE,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        api_version: "1.0",
      },
    }),
};

export default WhatsAppChattingApi;
